import api from './api';

function esIdValido(valor) {
  const numero = Number(valor);
  return Number.isInteger(numero) && numero > 0;
}

function validarId(valor, nombre = 'Id') {
  if (!esIdValido(valor)) throw new Error(`${nombre} no es válido.`);
  return Number(valor);
}
function normalizarNumeroDecimal(valor, nombre) {
  const numero = Number(valor);
  if (!Number.isFinite(numero) || numero <= 0) throw new Error(`${nombre} no es válido.`);
  return numero;
}

function normalizarEnteroOpcional(valor) {
  if (valor === null || valor === undefined || valor === '') return null;
  const numero = Number(valor);
  return Number.isInteger(numero) && numero > 0 ? numero : null;
}

function prepararPayloadEntradaCajaChica(payload = {}) {
  const reciboId = normalizarEnteroOpcional(payload.ReciboId ?? payload.reciboId);
  return {
    Monto: normalizarNumeroDecimal(payload.Monto ?? payload.monto, 'Monto'),
    Concepto: String(payload.Concepto ?? payload.concepto ?? '').trim(),
    Referencia: String(payload.Referencia ?? payload.referencia ?? '').trim() || null,
    FolioRecibo: String(payload.FolioRecibo ?? payload.folioRecibo ?? '').trim() || null,
    ReciboId: reciboId
  };
}

export function listarFondosCajaChica(params = {}) {
  return api.get('/caja-chica/fondos', { params }).then(res => res.data);
}

export function crearFondoCajaChica(payload) {
  return api.post('/caja-chica/fondos', payload).then(res => res.data);
}

export function editarFondoCajaChica(id, payload) {
  return api.put(`/caja-chica/fondos/${validarId(id, 'Fondo')}`, payload).then(res => res.data);
}

export function activarFondoCajaChica(id) {
  return api.post(`/caja-chica/fondos/${validarId(id, 'Fondo')}/activar`).then(res => res.data);
}

export function desactivarFondoCajaChica(id) {
  return api.post(`/caja-chica/fondos/${validarId(id, 'Fondo')}/desactivar`).then(res => res.data);
}

export function obtenerMisFondosCajaChica(params = {}) {
  return api.get('/caja-chica/mis-fondos', { params }).then(res => res.data);
}

export function listarUsuariosDisponiblesCajaChica() {
  return api.get('/caja-chica/usuarios-disponibles').then(res => res.data);
}

export function listarResponsablesFondoCajaChica(fondoId) {
  return api.get(`/caja-chica/fondos/${validarId(fondoId, 'Fondo')}/responsables`).then(res => res.data);
}

export function asignarResponsableFondoCajaChica(fondoId, payload = {}) {
  const usuarioId = validarId(payload.UsuarioId ?? payload.usuarioId, 'Usuario');
  const datos = {
    UsuarioId: usuarioId,
    PuedeRegistrarGastos: Boolean(payload.PuedeRegistrarGastos ?? payload.puedeRegistrarGastos),
    PuedeSubirEvidencia: Boolean(payload.PuedeSubirEvidencia ?? payload.puedeSubirEvidencia),
    PuedeVerSaldo: Boolean(payload.PuedeVerSaldo ?? payload.puedeVerSaldo)
  };
  return api.post(`/caja-chica/fondos/${validarId(fondoId, 'Fondo')}/responsables`, datos).then(res => res.data);
}

export function actualizarResponsableCajaChica(asignacionId, payload) {
  return api.put(`/caja-chica/responsables/${validarId(asignacionId, 'Asignación')}`, payload).then(res => res.data);
}

export function activarResponsableCajaChica(asignacionId) {
  return api.post(`/caja-chica/responsables/${validarId(asignacionId, 'Asignación')}/activar`).then(res => res.data);
}

export function desactivarResponsableCajaChica(asignacionId) {
  return api.post(`/caja-chica/responsables/${validarId(asignacionId, 'Asignación')}/desactivar`).then(res => res.data);
}

export function obtenerMisCajasChicas(params = {}) {
  return obtenerMisFondosCajaChica(params);
}

export function obtenerResumenCajaChica(cajaChicaId) {
  return api.get(`/caja-chica/${validarId(cajaChicaId, 'Caja chica')}/resumen`).then(res => res.data);
}

export function listarGastosCajaChica(cajaChicaId, params = {}) {
  return api.get(`/caja-chica/${validarId(cajaChicaId, 'Caja chica')}/gastos`, { params }).then(res => res.data);
}

export function registrarGastoCajaChica(cajaChicaId, payload) {
  return api.post(`/caja-chica/${validarId(cajaChicaId, 'Caja chica')}/gastos`, payload).then(res => res.data);
}

export function registrarFondeoCajaChica(cajaChicaId, payload) {
  return api.post(`/caja-chica/${validarId(cajaChicaId, 'Caja chica')}/fondeos`, prepararPayloadEntradaCajaChica(payload)).then(res => res.data);
}

export function registrarReposicionCajaChica(cajaChicaId, payload) {
  return api.post(`/caja-chica/${validarId(cajaChicaId, 'Caja chica')}/reposiciones`, prepararPayloadEntradaCajaChica(payload)).then(res => res.data);
}

export function subirEvidenciaGasto(gastoId, archivo) {
  const formData = new FormData();
  formData.append('archivo', archivo);
  return api.post(`/caja-chica/gastos/${validarId(gastoId, 'Gasto')}/evidencias`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(res => res.data);
}

export function listarEvidenciasGasto(gastoId) {
  return api.get(`/caja-chica/gastos/${validarId(gastoId, 'Gasto')}/evidencias`).then(res => res.data);
}

export function descargarEvidenciaGasto(gastoId, evidenciaId) {
  return api.get(`/caja-chica/gastos/${validarId(gastoId, 'Gasto')}/evidencias/${validarId(evidenciaId, 'Evidencia')}`, {
    responseType: 'blob'
  });
}

export function cancelarGastoCajaChica(gastoId, payload) {
  return api.post(`/caja-chica/gastos/${validarId(gastoId, 'Gasto')}/cancelar`, payload).then(res => res.data);
}

export function registrarArqueoCajaChica(cajaChicaId, payload) {
  return api.post(`/caja-chica/${validarId(cajaChicaId, 'Caja chica')}/arqueos`, payload).then(res => res.data);
}

export function listarArqueosCajaChica(cajaChicaId, params = {}) {
  return api.get(`/caja-chica/${validarId(cajaChicaId, 'Caja chica')}/arqueos`, { params }).then(res => res.data);
}

export function listarConceptosCajaChica(params = {}) {
  return api.get('/caja-chica/conceptos', { params }).then(res => res.data);
}

export function crearConceptoCajaChica(payload) {
  return api.post('/caja-chica/conceptos', payload).then(res => res.data);
}

export function editarConceptoCajaChica(id, payload) {
  return api.put(`/caja-chica/conceptos/${validarId(id, 'Concepto')}`, payload).then(res => res.data);
}

export function activarConceptoCajaChica(id) {
  return api.post(`/caja-chica/conceptos/${validarId(id, 'Concepto')}/activar`).then(res => res.data);
}

export function desactivarConceptoCajaChica(id) {
  return api.post(`/caja-chica/conceptos/${validarId(id, 'Concepto')}/desactivar`).then(res => res.data);
}
